module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Log In","subtitle":"Enter your email address and password to log in.","forget-password":"Don’t remember your password?"},"ru":{"title":"Войти","subtitle":"Введите электронную почту и пароль, чтобы войти в систему.","forget-password":"Забыли пароль?"}}')
  delete Component.options._Ctor
}
